import React from "react";
import { useReveal } from "../hooks/useReveal";
import Hero from "../components/Hero";
import StudioNews from "../components/StudioNews";
import YouthClassesCTA from "../components/YouthClassesCTA";
import Bio from "../components/Bio";
import SelectedWorks from "../components/SelectedWorks";
import StudioMerch from "../components/StudioMerch";
import RecentlyViewed from "../components/RecentlyViewed";
import RecentPlacements from "../components/RecentPlacements";
import BooksCTA from "../components/BooksCTA";
import StudioPrograms from "../components/StudioPrograms";
import UpcomingShows from "../components/UpcomingShows";
import CurrentlyShowing from "../components/CurrentlyShowing";
import ExhibitionHistory from "../components/ExhibitionHistory";
import NewsletterCTA from "../components/NewsletterCTA";

export default function Home() {
  useReveal();
  return (
    <>
      <Hero />
      <StudioNews />
      <Bio />
      <RecentlyViewed />
      <SelectedWorks />
      <RecentPlacements />
      <StudioMerch />
      <StudioPrograms />
      <UpcomingShows />
      <CurrentlyShowing />
      <ExhibitionHistory />
      <BooksCTA />
      <YouthClassesCTA />
      <NewsletterCTA />
    </>
  );
}
